import React, { useState } from "react";
import { Link } from "react-router-dom";
import { BRAND } from "../mock";
import Footer from "../components/Footer";

export default function Privacy() {
  const [scrolled, setScrolled] = useState(false);
  React.useEffect(() => {
    const s = () => setScrolled(window.scrollY > 40);
    s(); window.addEventListener("scroll", s, { passive: true });
    return () => window.removeEventListener("scroll", s);
  }, []);

  return (
    <div className="App">
      <nav className={`legal-nav${scrolled ? " scrolled" : ""}`}>
        <div className="inner">
          <Link to="/" className="logo">
            <img className="logo-white" src={BRAND.logoWhite} alt="Wynridge" />
            <img className="logo-ink" src={BRAND.logoInk} alt="Wynridge" />
          </Link>
          <div className="nl"><Link to="/" className="arrow-back">Back to site</Link></div>
        </div>
      </nav>

      <main className="legal card">
        <div className="inner">
          <span className="eyebrow">Legal</span>
          <h1 className="display legal-title">Privacy <em>Policy</em></h1>
          <p className="legal-meta">Last updated: July 8, 2025 · Wynridge Active Living Inc.</p>

          <p>Wynridge Active Living Inc. (“Wynridge”, “we”, “us”, or “our”) respects your privacy and is committed to protecting the personal information you share with us. This Privacy Policy explains how we collect, use, disclose, and safeguard your personal information in accordance with Canada's <em>Personal Information Protection and Electronic Documents Act</em> (PIPEDA), applicable provincial privacy laws, and Canada's Anti-Spam Legislation (CASL).</p>

          <h2>1. Information we collect</h2>
          <p>We collect only the personal information necessary for the purposes described below. Depending on how you interact with us, this may include:</p>
          <ul>
            <li><strong>Newsletter sign-ups:</strong> your email address.</li>
            <li><strong>Register your interest:</strong> your name, email address, phone number, city, and province.</li>
            <li><strong>Technical information:</strong> limited data your browser sends automatically, such as device and usage information, used to operate and secure the site.</li>
          </ul>

          <h2>2. How we use your information</h2>
          <p>We use your personal information to:</p>
          <ul>
            <li>Respond to your inquiry and register your interest in Wynridge communities;</li>
            <li>Send you community news, opening dates, and related updates you have asked to receive;</li>
            <li>Operate, maintain, and improve our website and services; and</li>
            <li>Comply with legal and regulatory obligations.</li>
          </ul>

          <h2>3. Consent (CASL)</h2>
          <p>By submitting your information, you consent to receive electronic messages from Wynridge relating to our communities and services. This is consent you provide expressly when you sign up. Every commercial electronic message we send will identify us and include an easy, no-cost way to unsubscribe. You may withdraw your consent at any time by using the unsubscribe link or by contacting us using the details in Section 11. We will action unsubscribe requests promptly, and in any case within 10 business days.</p>

          <h2>4. Disclosure of information</h2>
          <p>We do not sell, rent, or trade your personal information. We may share it only with trusted service providers who help us operate our website and communications (for example, hosting and email delivery), and only to the extent necessary to perform those services on our behalf under appropriate confidentiality obligations. We may also disclose information where required by law or to protect our legal rights.</p>

          <h2>5. Retention</h2>
          <p>We retain your personal information only for as long as necessary to fulfil the purposes described in this policy, or as required by law. When it is no longer needed, we will securely delete or anonymize it.</p>

          <h2>6. Safeguards</h2>
          <p>We use reasonable physical, organizational, and technological safeguards appropriate to the sensitivity of the information to protect it against loss, theft, and unauthorized access, disclosure, copying, use, or modification.</p>

          <h2>7. Access and correction</h2>
          <p>Subject to certain exceptions under applicable law, you have the right to access the personal information we hold about you and to request corrections. To make a request, contact our Privacy Officer using the details in Section 11.</p>

          <h2>8. Cookies and analytics</h2>
          <p>Our website may use cookies and similar technologies to enable core functionality and understand how the site is used. You can control cookies through your browser settings. Disabling cookies may affect some features of the site.</p>

          <h2>9. Third-party links</h2>
          <p>Our website may contain links to third-party websites. We are not responsible for the privacy practices of those sites and encourage you to review their privacy policies.</p>

          <h2>10. Children</h2>
          <p>Our website and services are intended for adults. We do not knowingly collect personal information from individuals under the age of majority.</p>

          <h2>11. Contact us / Privacy Officer</h2>
          <p>If you have questions about this policy, wish to access or correct your information, withdraw consent, or make a complaint, please contact our Privacy Officer:</p>
          <p><strong>Wynridge Active Living Inc.</strong><br />Attn: Privacy Officer<br />Email: <a href="mailto:hello@wynridge.ca">hello@wynridge.ca</a></p>
          <p>If you are not satisfied with our response, you may contact the Office of the Privacy Commissioner of Canada.</p>

          <h2>12. Changes to this policy</h2>
          <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated “Last updated” date.</p>

          <h2>13. Governing law</h2>
          <p>This Privacy Policy is governed by the laws of the Province of Ontario and the federal laws of Canada applicable therein.</p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
